<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Bina/Index.vue